<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-front-desk-modal-list">
      <h2>Deseja excluir a notificação de agravo pendente?</h2>
    </div>

    <div class="body-front-desk-modal-list">
      Você realmente deseja excluir esta Notificação? Ela perderá todas as alterações realizadas e essa opção é irreversível.
    </div>
    <div class="footer-front-desk-modal-list">
      <button mat-flat-button color="primary" class="btn-block" (click)="clickDelete()">
        @if (isLoading == false) {
          <span>Sim, excluir</span>
        }
        @if (isLoading == true) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
      <button mat-flat-button color="accent" class="btn-block"(click)="clickCancel()">Cancelar</button>
    </div>
  </div>
</div>